export const PLAN_ACCESS = "admin_matrix";
export const MAP_ACCESS = "admin_route_mapping_postcode";
export const ROUTE_ACCESS = "admin_depot_route";
export const SECTION_ACCESS = "admin_section_maint";
export const SHIFT_MANAGERS_ACCESS = "access_shift_manager_maintenance";
export const LOCK_OVERRIDE_ACCESS = "superuser_override_lock_on_route_matrix";
